export default __webpack_public_path__ + "static/media/f899f2535801ffd44b5aaa7407cc34f2.svg";